import {
  AmountType,
  BTGTDeal,
  DealType,
  DiscountDeal,
  FinancialConfigType,
  DefaultConutriesCodes,
  IModifier,
  ModifierGroup,
  ModifierOptions,
  OrderSource,
  RestaurantFinancialConfiguration,
  RestaurantTimingStatus,
  WeekDay,
  StockStatus,
  RestaurantTimingType,
  KitchenHubProviders,
} from '@zeus/shared';
import { cookieExpiryTime, message } from '../config/constants';
import { StaticImageData } from 'next/image';
import {
  Item,
  Restaurant,
  RestaurantTiming,
  Cart,
  NearbyRestaurants,
  CartItem,
  RestaurantInfo,
  OrderType,
  NearbyRestaurant,
  CategoryItem,
  MenuPageDataType,
  RestaurantTimingSlot,
} from '../app/(routes)/online-ordering/types';
import DefaultImage from '../resources/assets/defaultImage 2.png';
import biggerDefaultImage from '../resources/assets/menuitemplaceholder.png';
import { v4 as uuidv4 } from 'uuid';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { checkoutUrls } from '../config/routes';
import posthog from 'posthog-js';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { store } from '@store/online/index';
import { setState, setCheckoutErrors, updateCartSettings, updateOrderingTime } from '@store/online/cart/cartSlice';
import { cloneDeep } from 'lodash';
import { resetSelectedMenuDetails } from '@store/online/menu/menuSlice';
import { setRestaurantSetting } from '@store/online/restaurant/restaurantSlice';
import { removeUserAddressInfo, updateUserAuth } from '@store/online/auth/authSlice';
import { setDealItemsSelection } from '@store/online/deal/dealSlice';
import { getBusinessInfo } from '../services/business/business';
import { getCheckoutToken } from '../services/checkout/Checkout';
import { getRestaurantsClient } from '../services/restuarant/Restaurant';
import { decryptData } from './Crypto';
import moment from 'moment';
import { getAllMenuData, getMenuVersion } from '../services/menu/Menu';
import { RestaurantMetadata } from '@store/online/restaurant/restaurantSliceTypes';
import {
  setFilterAllergensAndTags,
  setItemAddOns,
  setItemByMenu,
  setMenuMetaData,
} from '@store/online/menu/menuMetadataSlice';
import { setVisibilitySettings } from '@store/online/settings/settingSlice';
import { CheckoutError } from '@store/online/cart/cartTypes';
import { StoreMenu } from '@store/online/menu/menuSliceTypes';
import * as QRCode from 'qrcode';

interface MyObject {
  [key: string]: string | boolean;
}
interface MetaTagParams {
  pageKey: string;
  restaurantName: string;
  restaurantAddress: string;
  tenantName?: string;
  favicon?: string;
}

export const checkUserAndItemAllergens = (itemAllergens: number[]) => {
  const userAllergens = store.getState().auth.userAllergens;
  if (Array.isArray(userAllergens) && userAllergens.length > 0) {
    return itemAllergens.some((itemAllergen) => userAllergens.includes(itemAllergen));
  }
  return false;
};

export const removeEmptyKeys = (obj: MyObject | any) => {
  const newObj: MyObject = {};
  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (value !== '') {
      newObj[key] = value;
    }
  }
  return newObj;
};

export const getImage = (
  image: string | null | undefined,
  itemDetail?: Item | CategoryItem
): { url: string | StaticImageData; isAvailable: boolean } => {
  if (image && image.includes('http')) {
    return { url: image, isAvailable: true };
  } else if ((!image || image.trim() === '') && !itemDetail) {
    return { url: DefaultImage, isAvailable: false };
  } else {
    return { url: biggerDefaultImage, isAvailable: false };
  }
};

export function truncateText(name: string | undefined | null, maxLength: number) {
  if (name)
    if (name?.length >= maxLength) {
      const newName = name?.slice(0, maxLength);
      return newName + '...';
    }
  return name;
}
export const roundToTwoDecimalPlaces = (value: number | string) => {
  if (typeof value === 'number') {
    // If the input is already a number, round it to two decimal places
    return Number(value.toFixed(2));
  } else if (typeof value === 'string') {
    // If the input is a string, attempt to convert it to a number and then round it
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
      return Number(parsedValue.toFixed(2));
    }
  }
  return value;
};
export const convertToAMPM = (time: string | null) => {
  if (!time) {
    return '';
  }

  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  const displayMinutes = minutes ? `:${minutes}` : ':00';
  const space = ' '; // Add space here
  return `${displayHour}${displayMinutes}${space}${ampm}`;
};

export const calculateTimeDifference = ({ timestamp }: { timestamp: string }) => {
  const currentTime = new Date().getTime(); // Get current time in milliseconds
  const createdAtTime = new Date(timestamp).getTime(); // Get the timestamp time in milliseconds
  const timeDifference = currentTime - createdAtTime;

  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  if (daysAgo === 0) {
    return 'Today';
  } else if (daysAgo > 360) {
    const yearsAgo = Math.floor(daysAgo / 365);
    return `${yearsAgo} year${yearsAgo === 1 ? '' : 's'} ago`;
  } else {
    return `${daysAgo} day${daysAgo === 1 ? '' : 's'} ago`;
  }
};

export const addDollarSigns = (price: string) => {
  if (price) {
    const parts = price?.split('.');
    if (parts?.length === 2) {
      return '$'.repeat(parts[0].length);
    }
    return '$'.repeat(price.length);
  } else {
    return '';
  }
};

export const DateTimeSplitter = (dateTimeString: string, type_date: string) => {
  const dateTime = new Date(dateTimeString);

  // Extract date and time parts
  if (type_date === 'date') {
    const year = dateTime.getFullYear();
    const month = dateTime.getMonth() + 1; // getMonth() returns a zero-based value, so we add 1 to get the actual month
    const day = dateTime.getDate();

    // Pad single-digit values with a leading zero
    const pad = (num: number) => (num < 10 ? '0' + num : num);

    const datePart = `${pad(month)}-${pad(day)}-${year}`;
    return datePart;
  } else {
    const timePart = dateTime.toLocaleTimeString();
    return timePart;
  }
};

export const formatValue = (value: number): string => `$${value}`;
export const convertDateFormat = (originalDate: any) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const [, month, dayNumber] = originalDate.split(' ');
  const monthIndex = months.indexOf(month);
  const year = new Date().getFullYear();

  const formattedDate = new Date(year, monthIndex, parseInt(dayNumber, 10));
  const isoDateString = formattedDate.toISOString().split('T')[0];

  return isoDateString;
};

export const truncatedLines = (name: string | undefined, charInLine: number, maxLines: number) => {
  return (name?.match(new RegExp(`.{1,${charInLine}}(\\s|$)`, 'g')) || []).slice(0, maxLines);
  //Max three lines, each line contains max 25 characters
};
export const capitalizeFirstLetter = (text: string) => {
  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
export const parseTimeString = (timeString: string) => {
  const [hours, minutes, seconds] = timeString.split(':');
  const date = new Date();
  date.setHours(parseInt(hours, 10), parseInt(minutes, 10), parseInt(seconds ?? '00', 10));
  return date;
};

export const openingHoursForCurrentDay = (
  setCurrentDayOpeningHours: React.Dispatch<React.SetStateAction<RestaurantTiming | undefined>>,
  resTimings: RestaurantTiming[] | undefined,
  currentDay: string,
  restaurantInfo: RestaurantInfo | NearbyRestaurant | undefined,
  isQr = false
) => {
  if (resTimings) {
    const isScheduledOrder = getCookie('scheduleOrder');
    const scheduledDate = getCookie('scheduledDate');

    let openingHoursForCurrentDay;
    if (isScheduledOrder && scheduledDate) {
      const scheduledDay = new Date(scheduledDate).toLocaleDateString('en-US', { weekday: 'long' }).toLocaleLowerCase();
      openingHoursForCurrentDay = resTimings?.find(
        (hours) =>
          hours.day === scheduledDay &&
          hours.type ===
            (restaurantInfo?.onlineOrderingSettings?.usePickUpHoursForScheduled
              ? RestaurantTimingType.PickupSlot
              : RestaurantTimingType.Schedule)
      );
    } else {
      openingHoursForCurrentDay =
        isQr || restaurantInfo?.onlineOrderingSettings?.useBusinessHoursForPickup
          ? resTimings?.find((hours) => hours.day === currentDay && hours.type === RestaurantTimingType.Restaurant)
          : resTimings?.find((hours) => hours.day === currentDay && hours.type === RestaurantTimingType.PickupSlot);
    }

    setCurrentDayOpeningHours(openingHoursForCurrentDay);
  }
};

export const getDayOfWeek = (dateString: string) => {
  const parts = dateString?.split(' ');
  if (parts) {
    const day = parseInt(parts[2], 10);
    const monthAbbreviation = parts[1];
    const year = new Date().getFullYear(); // Assuming current year
    const monthMap: { [key: string]: number } = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    };
    const month = monthMap[monthAbbreviation] as number;
    const date = new Date(year, month, day);
    const dayOfWeek = date.getDay();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dayOfWeek];
  }
};

export const checkRestaurantIsClosedOnScheduledTime = (
  restaurantTimings: RestaurantTiming[] | undefined,
  restaurantInfo: RestaurantInfo | NearbyRestaurant
) => {
  const scheduledDateLocal = getCookie('scheduledDate');

  let scheduledDate;
  if (scheduledDateLocal) {
    scheduledDate = new Date(scheduledDateLocal);
  }
  const scheduledSlot = getCookie('scheduledSlot');
  const formattedScheduledSlot = parseTimeString(scheduledSlot || '00:00:00').getTime();

  const scheduledDateDay = scheduledDate?.toLocaleDateString('en-US', { weekday: 'long' }).toLocaleLowerCase();
  const scheduledDayTimings = restaurantTimings?.find(
    (timing) =>
      timing.day === scheduledDateDay &&
      timing.type ===
        (restaurantInfo.onlineOrderingSettings?.usePickUpHoursForScheduled
          ? RestaurantTimingType.PickupSlot
          : RestaurantTimingType.Schedule)
  );

  const restaurantDayTimings = restaurantTimings?.find(
    (timing) => timing.day === scheduledDateDay && timing.type === RestaurantTimingType.Restaurant
  );

  if (scheduledDayTimings?.slots?.length && restaurantDayTimings?.slots?.length && scheduledSlot) {
    const isOpenOnScheduledDayTimings = scheduledDayTimings?.slots?.some((slot) => {
      const slotStartTime = parseTimeString(slot.startTime || '00:00:00').getTime();
      const slotEndTime = parseTimeString(slot.endTime || '23:59:59').getTime();
      return (
        formattedScheduledSlot >= slotStartTime &&
        formattedScheduledSlot <= slotEndTime &&
        scheduledDayTimings.status !== RestaurantTimingStatus.Closed
      );
    });

    const isOpenOnRestaurantDayTimings = restaurantDayTimings?.slots?.some((slot) => {
      const slotStartTime = parseTimeString(slot.startTime || '00:00:00').getTime();
      const slotEndTime = parseTimeString(slot.endTime || '23:59:59').getTime();
      return (
        formattedScheduledSlot >= slotStartTime &&
        formattedScheduledSlot <= slotEndTime &&
        restaurantDayTimings.status !== RestaurantTimingStatus.Closed
      );
    });

    if (!isOpenOnScheduledDayTimings || !isOpenOnRestaurantDayTimings) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const checkRestaurantOpeningHours = (
  currentDayOpeningHours: RestaurantTiming | undefined,
  setClosed: React.Dispatch<React.SetStateAction<boolean>>,
  selectedPickupDeliveryDate: string
) => {
  if (currentDayOpeningHours !== undefined) {
    if (!currentDayOpeningHours || !currentDayOpeningHours?.slots?.length) {
      setClosed(true);
      return;
    }

    const currentTime = new Date().getTime();

    // check if currentTime falls in slots start and end time..
    const isOpen = currentDayOpeningHours.slots.some((slot) => {
      const slotStartTime = parseTimeString(slot.startTime || '00:00:00').getTime();
      const slotEndTime = parseTimeString(slot.endTime || '23:59:59').getTime();
      return currentTime >= slotStartTime && currentTime <= slotEndTime;
    });

    if (!isOpen || currentDayOpeningHours.status === RestaurantTimingStatus.Closed) {
      setClosed(true);
    } else {
      setClosed(false);
    }
  } else {
    setClosed(false);
  }
  return;
};
export const debounce = <F extends (...args: any[]) => void>(func: F, wait: number) => {
  let timeout: NodeJS.Timeout;

  return function executedFunction(...args: Parameters<F>) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const extractMenuTime = (startTimeString?: string, endTimeString?: string): boolean => {
  // Check if both startTimeString and endTimeString are defined before proceeding
  if (startTimeString && endTimeString) {
    const [startTimePart] = startTimeString.split('+'); // Extract time part before '+'
    const [startHours, startMinutes, startSeconds] = startTimePart.split(':');

    const [endTimePart] = endTimeString.split('+'); // Extract time part before '+'
    const [endHours, endMinutes, endSeconds] = endTimePart.split(':');

    const currentTime = new Date();
    const startDate = new Date();
    startDate.setUTCHours(Number(startHours), Number(startMinutes), Number(startSeconds));

    const endDate = new Date();
    endDate.setUTCHours(Number(endHours), Number(endMinutes), Number(endSeconds));

    const menuOpen = currentTime >= startDate && currentTime <= endDate;
    return menuOpen;
  } else {
    // Handle the case when either startTimeString or endTimeString is undefined
    return false;
  }
};

export const convertToTimeZone = (timeString: string) => {
  if (!timeString) return '';
  const [h, m] = timeString.split(':').map(Number);
  const hour12 = h % 12 || 12;
  const ampm = h >= 12 ? 'PM' : 'AM';
  return `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`;
};
export const convertToTimeZoneUTC = (timeString: string) => {
  if (timeString) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setUTCHours(Number(hours), Number(minutes));
    return date.toLocaleString('en-US', { timeZone: userTimeZone, timeStyle: 'short' });
  } else {
    return '';
  }
};

export const formatDateToReadableString = (dateString: string) => {
  // Convert to a Date object
  const date = new Date(dateString);

  // Properly typed options for Intl.DateTimeFormat
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Format the date
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  return formattedDate;
};

export const isItemTimezoneMatch = (
  startTimeString: string | undefined,
  endTimeString: string | undefined
): boolean => {
  if (startTimeString === null || endTimeString === null || !startTimeString || !endTimeString) {
    return true;
  }
  const currentTime = new Date();

  // Extract the time and time zone offset from the start time string (assumes format "HH:mm:ss+00")
  const [startPart, startOffset] = startTimeString.split('+');
  const [startHours, startMinutes, startSeconds] = startPart.split(':');
  const startOffsetValue = parseInt(startOffset, 10);

  // Extract the time and time zone offset from the end time string (assumes format "HH:mm:ss+00")
  const [endPart, endOffset] = endTimeString.split('+');
  const [endHours, endMinutes, endSeconds] = endPart.split(':');
  const endOffsetValue = parseInt(endOffset, 10);

  // Create Date objects for start and end times, adjusting to the user's time zone
  const startDate = new Date();
  startDate.setUTCHours(Number(startHours), Number(startMinutes), Number(startSeconds));
  const userStartTime = new Date(startDate.getTime() + startOffsetValue * 60 * 1000);

  const endDate = new Date();
  endDate.setUTCHours(Number(endHours), Number(endMinutes), Number(endSeconds));
  const userEndTime = new Date(endDate.getTime() + endOffsetValue * 60 * 1000);

  // Check if the current time is within the range of start and end times

  return currentTime >= userStartTime && currentTime <= userEndTime;
};
export const isValidDecimal = (value: string) => {
  // to check the number is upto two decimal places and a valid number
  return /^\d+(\.\d{0,2})?$/.test(value);
};

export const calculateAmountFromPercentage = (amount: number, percentage: number) => {
  return Number((Math.round(amount * percentage) / 100).toFixed(2));
};
export const calculatePercentageFromAmount = (amount: number, tipAmount: number) => {
  if (amount === 0) return 0;
  return Number(((tipAmount / amount) * 100).toFixed(0));
};
export const calculateDistanceBetweenLatLng = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const R = 3958.8; // Radius of the Earth in miles
  const lat1Rad = toRadians(lat1);
  const lon1Rad = toRadians(lon1);
  const lat2Rad = toRadians(lat2);
  const lon2Rad = toRadians(lon2);

  const dlon = lon2Rad - lon1Rad;
  const dlat = lat2Rad - lat1Rad;

  const a = Math.sin(dlat / 2) ** 2 + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dlon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;
  return distance;
};

export const toRadians = (angle: number) => {
  return angle * (Math.PI / 180);
};
export const distanceCalculationsInMiles = (distanceWithUnit: number) => {
  const withoutUNit = distanceWithUnit?.toString()?.split(' ')[0]; //spit unity if exist
  const distanceInKm = Number(withoutUNit); //convert string back to number
  const distanceInMiles = distanceInKm * 0.621371;

  let result;

  if (distanceInMiles < 1) {
    result = calculateDistanceInMeters(distanceInKm) + ' away'; // Call calculateMeters function
  } else {
    result = distanceInMiles.toFixed(0) + ' Miles away'; // If the distance is already in miles, return it as is
  }

  return result;
};

export const calculateDistanceInMeters = (distanceWithUnit: number) => {
  const distanceInKm = distanceWithUnit; // This will extract the numerical value
  return (distanceInKm * 1000).toFixed(0) + ' Meters';
};

export const getAddressByBusinessId = () => {
  const businessId = store.getState()?.restaurant?.selectedBusinessId;
  const address: NearbyRestaurants = store.getState().restaurant.selectedRestaurantAddressNew;
  if (businessId && address[businessId] && address[businessId].restaurant) {
    return address[businessId].restaurant;
  }
};

export const getAddressByBusinessIdFromCookies = (businessId: any, address: any) => {
  if (address && address[businessId] && address[businessId]) {
    return address[businessId];
  }
};

export const getOrderingTimeById = () => {
  const businessId = store.getState()?.restaurant?.selectedBusinessId;
  const orderingTime = store.getState()?.cart?.orderingTime;
  if (businessId && orderingTime && orderingTime[businessId] && orderingTime[businessId].restaurant) {
    return orderingTime[businessId];
  }
  // Handle the case where orderingTime is not defined or does not contain the expected properties
  return null; // Or any other appropriate value
};

export const generatePseudoId = () => {
  return 'user-' + new Date().getTime() + '-' + uuidv4();
};

export const getPseudoId = () => {
  let pseudoId = store.getState().auth.pseudoId;
  if (!pseudoId) {
    pseudoId = generatePseudoId();
    store.dispatch(updateUserAuth({ pseudoId }));
  }
  return pseudoId;
};

export const fetchRestaurant = async (id: any) => {
  try {
    if (!id) return null;
    const rest = store.getState()?.restaurant?.activeRestaurant;
    if (rest?.restaurantId) {
      id = rest.restaurantId;
    }
    const restaurantData = await getRestaurantsClient(id);
    return restaurantData;
  } catch (error) {
    console.error('Failed to fetch restaurant data:', error);
  }
};

export const setUserAttribute = () => {
  const authUser = store.getState().auth.user;
  const ol_userPhoneNo = authUser?.phone ? decryptData(authUser?.phone) : null;
  const selectedRestaurantAddress: NearbyRestaurants = store.getState().restaurant.selectedRestaurantAddressNew;
  const restaurantId = selectedRestaurantAddress && Object.keys(selectedRestaurantAddress)[0];
  const fName = authUser?.fName ? decryptData(authUser?.fName) : null;
  const lName = authUser?.lName ? decryptData(authUser?.lName) : null;
  const ol_restaurantName =
    (selectedRestaurantAddress && selectedRestaurantAddress[restaurantId]?.restaurant?.name) || null;
  const rest_state =
    (selectedRestaurantAddress &&
      selectedRestaurantAddress[restaurantId]?.restaurant?.restaurantTimings?.[0]?.status) ||
    null;
  const ol_restID = (selectedRestaurantAddress && selectedRestaurantAddress[restaurantId]?.restaurant?.id) || null;
  const ol_userName = fName ? (lName ? `${fName} ${lName}` : fName) : null;
  const onlineOrderingSettings = store.getState().restaurant.onlineOrderingSettings;
  const user = {
    ol_userPhoneNo: ol_userPhoneNo,
    ol_restaurantName: ol_restaurantName,
    rest_state: rest_state,
    ol_userId: ol_userPhoneNo,
    ol_userName: ol_userName,
    ol_restID: ol_restID,
    ol_loggedIn: ol_userPhoneNo ? true : false,
    ol_isEnabled: onlineOrderingSettings,
  };

  return user;
};

export const setUserAttributeForQR = () => {
  const authUser = store.getState().auth.user;
  const qr_userPhoneNo = authUser?.phone ? decryptData(authUser?.phone) : null;
  const selectedRestaurantAddress: NearbyRestaurants = store.getState().restaurant.selectedRestaurantAddressNew;
  const restaurantId = selectedRestaurantAddress && Object.keys(selectedRestaurantAddress)[0];
  const fName = authUser?.fName ? decryptData(authUser?.fName) : null;
  const lName = authUser?.lName ? decryptData(authUser?.lName) : null;
  const qr_restaurantName =
    (selectedRestaurantAddress && selectedRestaurantAddress[restaurantId]?.restaurant?.name) || null;
  const rest_state =
    (selectedRestaurantAddress && selectedRestaurantAddress[restaurantId]?.restaurant?.restaurantTimings?.[0].status) ||
    null;
  const qr_restID = (selectedRestaurantAddress && selectedRestaurantAddress[restaurantId]?.restaurant?.id) || null;
  const qr_userName = fName ? (lName ? `${fName} ${lName}` : fName) : null;
  const user = {
    qr_userPhoneNo: qr_userPhoneNo,
    qr_restName: qr_restaurantName,
    rest_state: rest_state,
    qr_userId: qr_userPhoneNo,
    qr_userName: qr_userName,
    qr_restID: qr_restID,
    qr_loggedIn: qr_userPhoneNo ? true : false,
  };

  return user;
};

export const setUserPropertiesForGA = (eventAction?: any) => {
  type UserProperties = {
    ol_userName?: string;
    user_id?: string;
    ol_restaurantName?: string;
    ol_restID?: string;
    rest_state?: string;
    ol_loggedIn?: string;
    ol_userPhoneNo?: string;
    pseudo_id?: string;
  };

  const user = setUserAttribute();
  const pseudoId = getPseudoId();
  if (typeof window !== 'undefined' && window.gtag) {
    let userProperties: UserProperties = {};

    if (eventAction) {
      // Initialize only user_id and ol_userName when eventAction is provided
      userProperties.user_id = user.ol_userPhoneNo?.toString();
      userProperties.ol_userName = user.ol_userName ? user.ol_userName.toString() : '';
      userProperties.ol_userPhoneNo = user.ol_userPhoneNo ? user.ol_userPhoneNo.toString() : '';
      userProperties.pseudo_id = pseudoId;
    } else {
      // Initialize all properties when eventAction is not provided
      userProperties = {
        user_id: user.ol_userPhoneNo?.toString(),
        ol_userName: user.ol_userName ? user.ol_userName.toString() : '',
        ol_restaurantName: user.ol_restaurantName ? user.ol_restaurantName.toString() : '',
        ol_restID: user.ol_restID ? user.ol_restID.toString() : '',
        rest_state: user.rest_state ? user.rest_state.toString() : '',
        ol_loggedIn: user.ol_loggedIn ? user.ol_loggedIn.toString() : 'false',
        ol_userPhoneNo: user.ol_userPhoneNo ? user.ol_userPhoneNo.toString() : '',
        pseudo_id: pseudoId,
      };
    }

    window.gtag('set', {
      user_properties: userProperties,
    });
  }
};

export const removeLocalData = () => {
  store.dispatch(removeUserAddressInfo());
  store.dispatch(
    setRestaurantSetting({
      orderType: '',
      selectedPickupDeliveryDate: '',
      selectedCategory: null,
      selectedRestaurantAddressNew: {},
    })
  );
  store.dispatch(updateOrderingTime({ orderingTime: null }));
  store.dispatch(resetSelectedMenuDetails({}));
  store.dispatch(updateCartSettings({ userCartItem: null, item: null }));
};

export const resetScheduleOrderSettings = () => {
  deleteCookie('scheduleOrder');
  deleteCookie('scheduledDate');
  deleteCookie('scheduledSlot');
  store.dispatch(updateCartSettings({ selectedScheduleType: 'ASAP' }));
};

export const validateTimeSlotandDateOnCheckout = (startTime: string, endTime: string, selectedDate: string) => {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  const [startHour] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);

  const orderDate = new Date(selectedDate);

  if (now.getMonth() !== orderDate.getMonth() || now.getDate() !== orderDate.getDate()) {
    // If the order date is not today
    return false;
  }

  if (currentHour >= startHour && currentHour <= endHour && currentMinute <= endMinute) {
    return true;
  } else if (currentHour >= startHour && currentHour <= endHour) {
    return true;
  }
  return false;
};

export const getCurrentRestaurant = () => {
  const businessId = String(store.getState()?.restaurant?.selectedBusinessId);
  const selectedRestaurantAddress = store.getState()?.restaurant?.selectedRestaurantAddressNew as NearbyRestaurants;

  if (
    businessId &&
    selectedRestaurantAddress &&
    selectedRestaurantAddress[businessId] &&
    selectedRestaurantAddress[businessId].restaurant
  ) {
    return selectedRestaurantAddress[businessId].restaurant;
  }
  return {} as Restaurant;
};

export const sortObjectKeys = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObjectKeys);
  }

  const sortedKeys = Object.keys(obj).sort();
  const sortedObj: { [key: string]: any } = {};
  sortedKeys.forEach((key) => {
    sortedObj[key] = sortObjectKeys(obj[key]);
  });
  return sortedObj;
};

export const createFilteredModifiers = (selectedModifierGroups: ModifierGroup[], side: string) => {
  const result = [];

  for (const group of selectedModifierGroups) {
    const newGroup = {
      ...group,
      modifiers: [],
    };

    for (const modifier of group.modifiers || []) {
      const newModifier = {
        ...modifier,
        modifierOption: [] as ModifierOptions[],
        nestedModifiers: [],
      };

      if (modifier.pizzaSelection) {
        if (modifier.addNested && modifier.nestedModifiers) {
          for (const nestedModifier of modifier.nestedModifiers) {
            const newNestedModifier = {
              ...nestedModifier,
              modifierOption:
                (nestedModifier.modifierOption &&
                  nestedModifier.modifierOption.filter((option: ModifierOptions) => option.pizzaSide === side)) ||
                [],
            };

            if (newNestedModifier.modifierOption.length > 0) {
              (newModifier.nestedModifiers as IModifier[]).push(newNestedModifier);
            }
          }
        } else if (modifier.modifierOption) {
          newModifier.modifierOption = modifier.modifierOption.filter(
            (option: ModifierOptions) => option.pizzaSide === side
          ) as ModifierOptions[];
        }
      }

      if (newModifier.modifierOption.length > 0 || newModifier.nestedModifiers.length > 0) {
        (newGroup.modifiers as IModifier[]).push(newModifier);
      }
    }

    if (newGroup.modifiers.length > 0) {
      result.push(newGroup);
    }
  }
  return result;
};

export const createDefaultArray = (selectedModifierGroups: ModifierGroup[]) => {
  const defaultArray = [];

  for (const group of selectedModifierGroups) {
    const newGroup = {
      ...group,
      modifiers: [],
    };

    for (const modifier of group.modifiers || []) {
      if (!modifier.pizzaSelection) {
        const newModifier = {
          ...modifier,
          modifierOption: modifier.modifierOption,
          nestedModifier: modifier.nestedModifiers,
        };
        (newGroup.modifiers as IModifier[]).push(newModifier);
      }
    }

    if (newGroup.modifiers.length > 0) {
      defaultArray.push(newGroup);
    }
  }

  return defaultArray;
};

export const createModifierData = (selectedMods: ModifierGroup[]) => {
  const modNames: string[] = [];
  const modCount: number[] = [];
  const modPrice: number[] = [];

  for (const group of selectedMods) {
    for (const modifier of group?.modifiers || []) {
      if (modifier.addNested) {
        for (const nestedMod of modifier?.nestedModifiers || []) {
          for (const option of nestedMod?.modifierOption || []) {
            modNames.push(
              `${nestedMod?.modifierName || ''} (${option?.optionDisplayName || option?.optionName || ''})`
            );
            modCount.push(Number(option.orderedQuantity || 0));
            modPrice.push(Number(option.price || 0));
          }
        }
      } else {
        for (const option of modifier?.modifierOption || []) {
          modNames.push(option?.optionDisplayName || option?.optionName || '');
          modCount.push(Number(option.orderedQuantity || 0));
          modPrice.push(Number(option.price || 0));
        }
      }
    }
  }

  return { modNames, modCount, modPrice };
};

export const UsformatPhoneNumber = (value: string) => {
  const cleaned = value.replace(/\D/g, '');

  if (cleaned.length === 0) return '';
  if (cleaned.length <= 3) {
    return `(${cleaned}`;
  }
  if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }
  if (cleaned.length <= 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};

export const validatePhoneNumber = (raw: string): boolean => {
  const formatted = UsformatPhoneNumber(raw.replace(/\D/g, ''));
  const phoneNumberPattern = /^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$/;
  return phoneNumberPattern.test(formatted);
};

export const formatPhoneNumberInUsWith1 = (number: string | undefined) => {
  if (!number) return number;

  number = number.replace(/\D/g, ''); // Remove any non-numeric characters
  // Format the number into +x (xxx) xxx-xxxx
  return `+${number[0]} (${number.slice(1, 4)}) ${number.slice(4, 7)}-${number.slice(7)}`;
};

export const getModifierValidationText = (modifier: IModifier) => {
  if (modifier.noMaxSelection && modifier.minSelector === 0) {
    return '';
  } else if (modifier.noMaxSelection && modifier.minSelector && modifier.minSelector >= 1) {
    return `Select at least ${modifier.minSelector}`;
  } else if (
    modifier.isOptional &&
    modifier.modifierOption &&
    modifier.modifierOption.length === modifier.maxSelector
  ) {
    return '';
  } else if (modifier.minSelector === modifier.maxSelector) {
    return `Select any ${modifier.minSelector}`;
  } else if (!modifier.maxSelector) {
    return `Select at least ${modifier.minSelector}`;
  } else if (modifier.isOptional === true && modifier.minSelector === 0) {
    return `Select up to ${modifier.maxSelector}`;
  } else {
    return `Select between ${modifier.minSelector} and ${modifier.maxSelector}`;
  }
};

export const convertToCents = (amount: number) => {
  return Math.round(Number((amount ?? 0).toFixed(2)) * 100); // bill in cents
};

export const updateCartItemsValidations = (items: any) => {
  const businessId = store.getState()?.restaurant?.selectedBusinessId;
  const localCart: any = businessId ? store.getState()?.cart?.orderingTime?.[businessId]?.cart : null;
  const itemsDataFromLocal: Item[] = localCart?.items || [];
  let itemsUnavailable = false;

  if (!itemsDataFromLocal.length) return;

  const updatedItems = itemsDataFromLocal?.map((localItem: Item) => {
    const cartItem = items?.find((item: any) => item.id === localItem.id);
    const currentItem = cartItem ? { ...(cartItem.item || cartItem) } : {};
    if (cartItem) {
      return {
        ...cartItem,
        ...localItem,
        stockStatus: cartItem?.stockStatus,
        isSettingsVisible: cartItem?.isSettingsVisible,
        visibility: cartItem?.visibility,
      };
    } else {
      itemsUnavailable = true;
      return {
        ...currentItem,
        ...localItem,
        stockStatus: 'false',
        isSettingsVisible: false,
        visibility: currentItem?.visibility,
      };
    }
  });

  const orderingTime = cloneDeep(store.getState()?.cart?.orderingTime);
  if (businessId && orderingTime && orderingTime[businessId]) {
    orderingTime[businessId].cart.items = updatedItems;
  }
  store.dispatch(updateOrderingTime({ orderingTime }));

  return itemsUnavailable;
};

export const updateLocalCartItemsValidations = (items: any) => {
  const businessId = store.getState()?.restaurant?.selectedBusinessId;
  const localCart: any = businessId ? store.getState()?.cart?.carts?.[businessId]?.cart : null;
  const itemsDataFromLocal: Item[] = localCart?.items || [];
  let itemsUnavailable = false;

  if (!itemsDataFromLocal.length) return;

  const updatedItems = itemsDataFromLocal?.map((localItem: Item) => {
    const cartItem = items?.find((item: any) => item.id === localItem.id);
    const currentItem = cartItem ? { ...(cartItem.item || cartItem) } : {};
    if (cartItem) {
      return {
        ...cartItem,
        ...localItem,
        stockStatus: cartItem?.stockStatus,
        isSettingsVisible: cartItem?.isSettingsVisible,
        visibility: cartItem?.visibility,
      };
    } else {
      itemsUnavailable = true;
      return {
        ...currentItem,
        ...localItem,
        stockStatus: 'false',
        isSettingsVisible: false,
        visibility: currentItem?.visibility,
      };
    }
  });

  store.dispatch(
    setState({
      items: updatedItems,
      itemsUnavailable,
      ...(!itemsUnavailable && { showOutStockError: false }),
    })
  );

  return itemsUnavailable;
};

// export const checkTimeBasedAvailability = (
//   item: any,
//   selectedPickupDeliveryDate: string = new Date().toISOString()
// ) => {
//   if (!item?.visibility || item?.visibility?.isDefault) {
//     return true;
//   }

//   const selectedDayOfWeek: WeekDay = selectedPickupDeliveryDate
//     ? getWeekDayFromDate(selectedPickupDeliveryDate)
//     : getWeekDayFromDate(new Date().toISOString());
//   const scheduleForDay = item?.visibility?.schedules?.[selectedDayOfWeek];

//   if (scheduleForDay) {
//     const daySchedule = scheduleForDay;
//     if (daySchedule.availabilityType === 'AllDay') {
//       return true;
//     } else if (daySchedule.availabilityType === 'PartialDay') {
//       const currentTime = new Date(selectedPickupDeliveryDate || new Date()).toTimeString().split(' ')[0];
//       if (daySchedule.startTime && daySchedule.endTime) {
//         return currentTime >= daySchedule.startTime && currentTime <= daySchedule.endTime;
//       }
//     }
//   } else {
//     return false;
//   }
//   return true;
// };

export const checkSlotExists = (scheduledDateTime: string, restaurantTiming: RestaurantTiming[]) => {
  const scheduledDate = new Date(scheduledDateTime);

  const weekday = scheduledDate.toLocaleDateString('en-US', { weekday: 'long' });

  const scheduledTime = scheduledDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const timingForDay = restaurantTiming.find((rt) => rt.day.toLowerCase() === weekday.toLowerCase());

  if (!timingForDay?.startTime || !timingForDay?.endTime || timingForDay.status === RestaurantTimingStatus.Closed) {
    return false;
  }

  return scheduledTime >= timingForDay.startTime && scheduledTime <= timingForDay.endTime;
};
export const isDeliveryEnabled = (restaurant?: RestaurantInfo | NearbyRestaurant): boolean => {
  const doorDashDrive = restaurant?.kitchenHubInfo?.find(
    (hub) => hub?.partnerName === KitchenHubProviders.DoordashDrive
  );
  return doorDashDrive?.deliveryEnabled === true;
};
export const maxDistanceAllowed = (restaurant?: RestaurantInfo | NearbyRestaurant): { miles: number; km: number } => {
  const doorDashDrive = restaurant?.kitchenHubInfo?.find(
    (hub) => hub?.partnerName === KitchenHubProviders.DoordashDrive
  );
  return {
    km: Number(doorDashDrive?.deliveryRadius || 10) * 1.60934, //default 10 inCase no restaurant data available(before selecting location)
    miles: Number(doorDashDrive?.deliveryRadius || 10),
  };
};

export const orderValidationLocal = async (restaurant?: RestaurantInfo | NearbyRestaurant) => {
  let scheduleOrderFireTime = 0;
  if (restaurant?.id) {
    const { data } = await getRestaurantsClient(restaurant?.id);
    scheduleOrderFireTime = data?.restaurant?.scheduleOrderFireTime || 0;
  }
  const isScheduledOrder = Boolean(getCookie('scheduleOrder'));
  const orderType = store.getState().restaurant.orderType;

  const settings = restaurant?.onlineOrderingSettings;
  const isPickupDisabled = orderType === OrderType.Takeaway && !settings?.isPickupEnabled;
  const isDeliveryDisabled = orderType === OrderType.Delivery && !isDeliveryEnabled(restaurant);
  const inValidOrderType = isPickupDisabled || isDeliveryDisabled;
  const orderSchedulingEnabled = Boolean(restaurant?.orderSchedulingEnabled);

  if (!isScheduledOrder) {
    return {
      isScheduledOrder: false,
      timeExpired: false,
      inValidOrderType,
      orderSchedulingEnabled,
    };
  }

  const scheduledDateStr = getCookie('scheduledDate');
  const scheduledSlot = getCookie('scheduledSlot'); // e.g., "14:00"

  let timeExpired = false;
  if (scheduledDateStr && scheduledSlot) {
    const date = new Date(scheduledDateStr);
    const dateString = date.toLocaleDateString('en-CA'); // YYYY-MM-DD
    const scheduledDateTime = new Date(`${dateString}T${scheduledSlot}`);
    const availableTime = new Date(scheduledDateTime.getTime() - (scheduleOrderFireTime || 0) * 60000);
    timeExpired = new Date().getTime() > availableTime.getTime();
  }

  return {
    isScheduledOrder,
    timeExpired,
    orderSchedulingEnabled,
    inValidOrderType,
  };
};

export const getVisibilityParams = (isQr?: string, isUtcTime?: boolean, isQSR = true) => {
  const isScheduledOrder = getCookie('scheduleOrder');

  let now = new Date();

  if (isScheduledOrder) {
    const scheduledDate = getCookie('scheduledDate');
    const scheduledSlot = getCookie('scheduledSlot');

    if (scheduledDate && scheduledSlot) {
      const [hours, minutes] = scheduledSlot.split(':');
      const scheduled = new Date(scheduledDate);
      scheduled.setHours(parseInt(hours));
      scheduled.setMinutes(parseInt(minutes));
      scheduled.setSeconds(0);
      scheduled.setMilliseconds(0);

      now = scheduled;
    }
  }

  // Get the day of the week in abbreviated format
  const optionsDay: Intl.DateTimeFormatOptions = { weekday: 'short' };
  const day = new Intl.DateTimeFormat('en-US', optionsDay).format(now);

  // Get the time in 'HH:MM:SS' format
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  const timeStringWithTimezone = now.toISOString().split('T')[1];
  const time = isUtcTime ? timeStringWithTimezone.split('.')[0] : `${hours}:${minutes}:${seconds}`;

  let appType;
  if (isQr && isQr === 'true' && isQSR) {
    appType = 'QR';
  } else {
    appType = getCookie('isQr') === 'true' && isQSR ? 'QR' : 'Online';
  }

  return {
    deviceDay: day,
    deviceTime: time,
    deviceDate: now.toISOString(),
    deviceType: appType,
  };
};

export const formatCardNumber = (value: string) => {
  return value.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
};

export const unFormatCardNumber = (formattedValue: string) => {
  return formattedValue.replace(/\s/g, '').substring(0, 19);
};

export const unformatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/[^0-9+]/g, '');
};

export const getAvailablePoints = (userPoints: number | undefined, pointsUsed: number | undefined) => {
  const pointsAvailable = userPoints ? userPoints : 0;
  const pointsRedeemed = pointsUsed ? pointsUsed : 0;

  return Math.max(pointsAvailable - pointsRedeemed, 0);
};

// Helper function to compare arrays
export const arraysEqual = (a: number[], b: number[]) => JSON.stringify(a) === JSON.stringify(b);
export const createPrepareCartPayload = (cart: Cart, isQr: boolean) => {
  const cartItems = (cart.items || []).map((item: any) => {
    const newItem = structuredClone(item);
    if (item?.dealItemType && item?.dealItemType === 'buy') {
      delete newItem?.dealId;
    }
    return newItem;
  });
  const storeCustomerUsername = decryptData(store.getState().auth.user?.customerUserName || '');
  const payload: Cart = {
    items: cartItems,
    customerUsername: cart.customerUsername || storeCustomerUsername,
    restaurantId: cart.restaurantId,
    businessId: cart.businessId,
    estimatedTimeSlotId: cart.estimatedTimeSlotId,
    guestSessionId: cart.guestSessionId,
    orderSource: isQr ? OrderSource.QR : OrderSource.Website,
    order_type: cart.order_type,
    address: cart.address,
    apartment: cart.apartment,
    latitude: cart.latitude,
    longitude: cart.longitude,
    city: cart.city,
    state: cart.state,
    street: cart.street,
    zipCode: cart.zipCode,
    totalBill: cart.totalBill,
    ...(cart?.dealId && {
      dealId: Number(cart?.dealId),
    }),
  };
  if (cart?.is_gift_card_applied) {
    payload['is_gift_card_applied'] = cart?.is_gift_card_applied;
    payload['user_gift_card_id'] = cart?.user_gift_card_id;
    payload['giftCardAmount'] = cart?.giftCardAmount;
  }

  return payload;
};
export const transferSessionToCookies = () => {
  const sub = sessionStorage.getItem('sub');
  const accessToken = sessionStorage.getItem('AccessToken');
  const refreshToken = sessionStorage.getItem('RefreshToken');
  const idToken = sessionStorage.getItem('IdToken');

  // Function to set cookies
  const cookieOptions = { maxAge: cookieExpiryTime }; // 30 days

  // Set cookies if values exist
  if (sub) setCookie('sub', sub, cookieOptions);
  if (accessToken) setCookie('AccessToken', accessToken, cookieOptions);
  if (refreshToken) setCookie('RefreshToken', refreshToken, cookieOptions);
  if (idToken) setCookie('IdToken', idToken, cookieOptions);
};

// Helper function to construct the final URL
export const constructFinalUrl = async (
  isQr: boolean | undefined,
  paylater: boolean | undefined,
  ticketId: number | undefined,
  tableNo: null | string | undefined,
  ticketIds: []
) => {
  try {
    const pathname = window.location.href;
    const currentRestaurant = getCurrentRestaurant();
    const restaurantId = currentRestaurant.id;
    const dataToTokenize = { ticketId };
    const resp = await getCheckoutToken(dataToTokenize, restaurantId);
    const token = await resp.data;
    const baseUrl = pathname.replace(checkoutUrls.onlineOrdering, checkoutUrls.postOrdering);

    return isQr
      ? paylater
        ? `${baseUrl}&ticketIds=${ticketIds}&tableNo=${tableNo}`
        : `${baseUrl}&token=${token}`
      : `${baseUrl}?token=${token}`;
  } catch (err) {
    console.error('Error constructing final URL:', err);
    return '/'; // Fallback URL
  }
};

export const handleRemoveCountryCode = (phoneNumber: string) => {
  const escapedCodes = DefaultConutriesCodes.map((code) => `\\${code}`); // Escape the '+' in each code
  const countryRegex = new RegExp(`^(${escapedCodes.join('|')})`);

  return phoneNumber.replace(countryRegex, '');
};

export const getWeekDayFromDate = (dateString: string): WeekDay => {
  // Handle "Wed Jan 07" explicitly
  if (/^[A-Za-z]{3} [A-Za-z]{3} \d{2}$/.test(dateString)) {
    const short = dateString.slice(0, 3).toUpperCase();
    return WeekDay[short as keyof typeof WeekDay];
  }

  // Handle ISO / standard date strings
  const d = new Date(dateString);

  if (!isNaN(d.getTime())) {
    const map: WeekDay[] = [WeekDay.SUN, WeekDay.MON, WeekDay.TUE, WeekDay.WED, WeekDay.THU, WeekDay.FRI, WeekDay.SAT];

    return map[d.getDay()];
  }

  throw new Error('Invalid date string');
};
export const getFormattedDate = (): string => {
  const date = new Date();
  const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(date);
  return `${weekday} ${month} ${day}`;
  // Call the function to transfer values
};
export const menuItemJsonLd = (itemDetail: any) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'MenuItem',
    name: itemDetail.itemName,
    description: itemDetail.itemDescription || '',
    image: [itemDetail.onlineImage, itemDetail.landscapeImage],
    offers: {
      '@type': 'Offer',
      price: itemDetail.itemPrice,
      priceCurrency: 'USD',
      availability: itemDetail.stockStatus === 'true' ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
    },
    category: {
      '@type': 'CategoryCode',
      name: `Category ID: ${itemDetail?.category?.[0]?.id ?? ''}`,
    },
  };
};

export const restaurantJsonLd = (currentRes: any) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Restaurant',
    name: currentRes?.restaurantName,
    address: currentRes?.restaurantAddress,
  };
};

export const generateMetaTags = async ({ pageKey, restaurantName, tenantName }: MetaTagParams) => {
  // let favicon;
  let resturantName;
  let restaurantAddress;
  if (tenantName) {
    const businessData = await getBusinessInfo(tenantName ?? '');
    // favicon = businessData?.data?.logo;
    resturantName = businessData?.data?.restaurants[0]?.name;
    restaurantAddress = businessData?.data?.restaurants[0]?.address;
  }
  const metaMapping: Record<string, { title: string; description?: string }> = {
    restaurant: {
      title: `Order | ${resturantName} | ${restaurantAddress ?? ''} Menu & Prices | AIO`,
    },
    item: {
      title: `Order | ${restaurantName} | ${restaurantAddress} | Menu & Prices | AIO`,
    },
    cart: {
      title: `Order | ${restaurantName} | Cart | AIO`,
    },
    checkout: {
      title: `Order | ${restaurantName} | Checkout | AIO`,
    },
    postOrdering: {
      title: `Order | ${restaurantName} | Track your order | AIO`,
    },
    myaccount: {
      title: `Order | AIO | My Account`,
    },
    myorders: {
      title: `Order | AIO | My Orders`,
    },
    restaurantInfo: {
      title: `Order | AIO | Restaurant Info`,
    },
    login: {
      title: `Order | AIO | Login`,
    },
    signup: {
      title: `Order | AIO | Signup`,
    },
    diet: {
      title: `Order | AIO | Diet preferences`,
    },
    personalinfo: {
      title: `Order | AIO | Personal Information`,
    },
    qr: {
      title: `Order | ${restaurantName} | ${restaurantAddress} | Menu & Prices | AIO`,
    },
  };

  const meta = metaMapping[pageKey];
  if (!meta) {
    throw new Error(`No metadata defined for pageKey: ${pageKey}`);
  }
  const defaultDescription = `Get takeout from ${resturantName}. Order online and track your order in real-time.`;
  const description = defaultDescription || meta.description;
  return {
    title: meta.title,
    description: description,
    openGraph: {
      title: meta.title,
      description: description,
    },
    // icons: {
    //   icon: favicon,
    // },
  };
};

// TODO (Will be removed or handle properly once online flows are stable)
export const getMenuOnlyFlag = (): boolean => {
  const menuOnly = getCookie('menuOnlyFlow');

  return menuOnly && menuOnly == 'true' ? true : false;
};

const getPersonProperties = () => {
  const isQr = store.getState().restaurant.isQr;
  return isQr ? setUserAttributeForQR() : setUserAttribute();
};
export const sendEventToPostHog = (eventType: string, eventAction: string, eventProperties?: any) => {
  const personProperties = getPersonProperties();

  // Capture event
  posthog.capture(eventAction, {
    event_type: eventType,
    $set: {
      ...personProperties,
    },
    ...eventProperties,
  });
};

export const prepareNuggetEventPayload = (data: any) => {
  const payload = {
    restaurantId: data.restaurantId,
    type: data.type,
    data: {
      cartId: data.cartId,
      nuggetId: data.nuggetId,
      type: data.type,
      restaurantId: data.restaurantId,
    },
  };

  return payload;
};

export const checkTaxInclusiveInRestaurant = (financialConfigurations?: RestaurantFinancialConfiguration | null) => {
  if (
    financialConfigurations &&
    financialConfigurations.configType === FinancialConfigType.TAX &&
    financialConfigurations.isTaxInclusive
  ) {
    return true;
  }

  return false;
};

export const splitName = (name: string) => {
  const nameParts = name.split(' ');
  let fName = '';
  let lName = '';

  if (nameParts.length === 1) {
    fName = nameParts[0];
    lName = '';
  } else if (nameParts.length >= 2) {
    fName = nameParts[0];
    lName = nameParts.slice(1).join(' ');
  }

  return { fName, lName };
};

export const getDealBasedItemPrice = (deal: any, basePrice: number) => {
  if (deal) {
    let price = 0;

    //check deal type
    switch (deal?.type) {
      case DealType.BTGT:
      case DealType.DISCOUNT: {
        const dealDetails = deal.details as BTGTDeal | DiscountDeal;

        if (dealDetails.type === AmountType.PRICE) {
          price = Math.max(0, (basePrice || 0) - dealDetails.amount);
        } else if (dealDetails.type === AmountType.PERCENTAGE) {
          if (dealDetails.amount === 100) {
            price = 0;
          } else {
            price = (basePrice || 0) - (basePrice || 0) * (dealDetails.amount / 100);
          }
        }
        break;
      }
      case DealType.GIFT_WITHOUT_PURCHASE:
      case DealType.GIFT_WITH_PURCHASE: {
        price = 0;
        break;
      }
      default: {
        break;
      }
    }

    return Number(price.toFixed(2));
  }

  return Number(basePrice.toFixed(2));
};

export const saveDealItemLocally = (dealItem: any) => {
  const dealItemsSelection = store.getState()?.deal?.dealItemsSelection || [];

  const updatedSelection = dealItemsSelection.map((item: any) =>
    item.id === dealItem.id && item.dealId === dealItem.dealId && item.dealItemType === dealItem.dealItemType
      ? dealItem
      : item
  );

  if (
    !dealItemsSelection.some(
      (item: any) =>
        item.id === dealItem.id && item.dealId === dealItem.dealId && item.dealItemType === dealItem.dealItemType
    )
  ) {
    updatedSelection.push(dealItem);
  }

  store.dispatch(setDealItemsSelection({ dealItemsSelection: [...updatedSelection] }));
};

export const saveDealListLocally = (dealList: any) => {
  const safeCopy = JSON.parse(JSON.stringify(dealList));
  store.dispatch(setDealItemsSelection({ dealItemsSelection: safeCopy }));
};

export const getDealItemsLocally = () => {
  return store.getState()?.deal?.dealItemsSelection || [];
};

export const getDealItemByIdLocally = (itemId: number, dealId?: number, dealItemType?: string) => {
  const dealItemsSelection = store.getState()?.deal?.dealItemsSelection || [];

  return dealItemsSelection.find(
    (item: any) => item.id === itemId && item.dealId === dealId && (!dealItemType || item.dealItemType === dealItemType)
  );
};

export const handleGetAppliedDeals = (cart?: Cart) => {
  const isQr = store.getState().restaurant.isQr;
  const visibilityParams = getVisibilityParams(`${isQr}`, false);
  const { deviceDay, deviceDate } = visibilityParams || {};
  const dayOfWeek: WeekDay = deviceDay as WeekDay;

  const items: CartItem[] = cart?.items || [];
  const withDealItemsMap = new Map();

  items.forEach((item, index) => {
    if (item?.dealId || item?.deal?.id) {
      const isAvailable =
        item?.deal &&
        moment.utc(item?.deal.startDate).isSameOrBefore(moment.utc(deviceDate), 'day') &&
        moment.utc(item?.deal.endDate).isSameOrAfter(moment.utc(deviceDate), 'day') &&
        new Date(item?.deal.startTime) <= new Date(deviceDate) &&
        new Date(item?.deal.endTime) >= new Date(deviceDate) &&
        item?.deal.days.includes(dayOfWeek);
      // Determine the deal ID (from dealId or deal.id)
      const dealId = item.dealId || item?.deal?.id;
      const dealKey = `deal_${dealId}`;

      // If this deal group doesn't exist, create it
      if (!withDealItemsMap.has(dealKey)) {
        withDealItemsMap.set(dealKey, {
          dealId,
          deal: item.deal,
          dealItemType: item.dealItemType,
          items: [],
          originalPrice: 0, // Initialize total original price
          discountedPrice: 0,
          isAvailable,
        });
      }

      let originalPrice = item?.itemPrice || 0;

      for (const group of item?.selectedModifierGroups || []) {
        for (const modifier of group?.modifiers || []) {
          if (modifier?.addNested) {
            for (const nestedModifier of modifier?.nestedModifiers || []) {
              for (const option of nestedModifier?.modifierOption || []) {
                originalPrice += option?.originalPrice || option?.price || 0;
              }
            }
          } else {
            for (const option of modifier?.modifierOption || []) {
              originalPrice += option?.originalPrice || option?.price || 0;
            }
          }
        }
      }
      const updatedItem = { ...item };
      updatedItem.originalPrice = originalPrice * item?.orderedQuantity;

      // Add item to its respective deal group
      const dealGroup = withDealItemsMap.get(dealKey);
      dealGroup.items.push(updatedItem);
      dealGroup.originalPrice += updatedItem.originalPrice;
      dealGroup.discountedPrice += updatedItem?.discountedPrice;
    }
  });

  if (cart?.dealId && cart?.deal && (cart?.deal?.details as any)?.isEntire) {
    const isAvailable =
      cart?.deal &&
      moment.utc(cart?.deal.startDate).isSameOrBefore(moment.utc(deviceDate), 'day') &&
      moment.utc(cart?.deal.endDate).isSameOrAfter(moment.utc(deviceDate), 'day') &&
      new Date(cart?.deal.startTime) <= new Date(deviceDate) &&
      new Date(cart?.deal.endTime) >= new Date(deviceDate) &&
      cart?.deal.days.includes(dayOfWeek);

    const dealId = cart?.dealId || cart?.deal?.id;
    const dealKey = `deal_${dealId}`;
    withDealItemsMap.set(dealKey, {
      dealId: cart?.dealId,
      deal: cart?.deal,
      dealItemType: '',
      items: [],
      originalPrice: 0, // Initialize total original price
      discountedPrice: 0,
      isAvailable,
    });
  }

  // Convert Map values to an array
  return Array.from(withDealItemsMap.values());
};

export const handleGetFormattedDate = (dateString: string) => {
  const today = new Date(dateString);
  const formattedDate = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return formattedDate;
};
export const getScheduleConfiguration = () => {
  const isScheduledOrder = getCookie('scheduleOrder');
  if (isScheduledOrder) {
    let dateToReturn;
    const scheduledDate = getCookie('scheduledDate');
    const scheduledSlot = getCookie('scheduledSlot');
    if (scheduledDate && scheduledSlot) {
      const formattedDate = new Date(scheduledDate);
      const year = formattedDate.getFullYear();
      const month = formattedDate.getMonth(); // ⚠️ 0-based (0 = January)
      const day = formattedDate.getDate();
      const [hours, minutes] = scheduledSlot.split(':').map(Number);
      dateToReturn = new Date(year, month, day, hours, minutes);
    }

    return {
      isScheduledOrder: true,
      scheduledDateTime: dateToReturn,
    };
  } else {
    return {
      isScheduledOrder: false,
      scheduledDateTime: null,
    };
  }
};

export function convertTo12HourFormat(time24: string): string {
  const [hourStr, minute] = time24.split(':');
  let hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  if (hour === 0) hour = 12;

  return `${hour}:${minute} ${ampm}`;
}

export function reviewsFormat(reviews: number): string {
  if (reviews >= 1_000_000) {
    return (reviews / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (reviews >= 1_000) {
    return (reviews / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return reviews.toString();
}

export const currencyFormatter = (amount: number) => {
  return (
    Number(amount)?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    }) ||
    (0.0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })
  );
};

export const formatWithCommas = (num: number) => {
  return num.toLocaleString();
};

export const waitForNavigation = (router: AppRouterInstance, prevPath: string, targetPath?: string) =>
  new Promise<void>((resolve) => {
    const checkPathChange = () => {
      if (window.location.pathname !== prevPath) {
        resolve();
      } else {
        requestAnimationFrame(checkPathChange);
      }
    };
    if (targetPath) {
      router.push(targetPath);
    } else {
      router.back();
    }
    requestAnimationFrame(checkPathChange);
  });

export const createProductIdChecker = (menuData: any[]) => {
  const productIdSet = new Set();

  if (Array.isArray(menuData)) {
    menuData.forEach((category) => {
      if (category.items && Array.isArray(category.items)) {
        category.items.forEach((item: any) => {
          if (item.id !== undefined) {
            productIdSet.add(Number(item.id));
          }
        });
      }
    });
  }

  return function (productId: number) {
    return productIdSet.has(productId);
  };
};

export const checkTimeBasedAvailability = (visibilitySettings: any) => {
  try {
    const isQr = store.getState()?.restaurant.isQr;
    const isCatering = store.getState()?.restaurant.isCatering;
    let selectedPickupDeliveryDate =
      getOrderingTimeById()?.orderingTime?.selectedPickupDeliveryDate ||
      store.getState()?.restaurant.selectedPickupDeliveryDate;

    // Check if this is a scheduled order and use the scheduled date instead
    const isScheduledOrder = getCookie('scheduleOrder');
    if (isScheduledOrder) {
      const scheduledDate = getCookie('scheduledDate');
      if (scheduledDate) {
        selectedPickupDeliveryDate = scheduledDate;
      }
    }

    const currentDate = new Date().toISOString();
    let settings: any = null;
    if (visibilitySettings) {
      if (isQr) {
        settings = visibilitySettings?.['QR'] ?? visibilitySettings?.['OnPrem'];
      } else if (isCatering) {
        settings = visibilitySettings?.['Catering'] ?? visibilitySettings?.['OffPrem'];
      } else {
        settings = visibilitySettings?.['Online'] ?? visibilitySettings?.['OffPrem'];
      }
      if (!settings) {
        return false;
      }
      if (!settings || settings?.isDefault) {
        return true;
      }
      const selectedDayOfWeek: WeekDay = selectedPickupDeliveryDate
        ? getWeekDayFromDate(selectedPickupDeliveryDate)
        : getWeekDayFromDate(currentDate);
      const scheduleForDay = settings?.daySchedules[selectedDayOfWeek];
      if (scheduleForDay) {
        const daySchedule = scheduleForDay;
        if (daySchedule.availabilityType === 'AllDay') {
          return true;
        } else if (daySchedule.availabilityType === 'PartialDay') {
          // For scheduled orders, use the scheduled time; otherwise use current time
          let timeToCheck = new Date().toTimeString().split(' ')[0];

          if (isScheduledOrder) {
            const scheduledSlot = getCookie('scheduledSlot'); // Format: "HH:MM"
            if (scheduledSlot) {
              // Normalize to HH:MM:SS to match startTime/endTime format
              timeToCheck = scheduledSlot.length === 5 ? `${scheduledSlot}:00` : scheduledSlot;
            }
          }

          if (daySchedule.startTime && daySchedule.endTime) {
            return timeToCheck >= daySchedule.startTime && timeToCheck <= daySchedule.endTime;
          }
        }
      } else {
        return false;
      }
    }
    return false; // if visibility setting not exist of that item
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getVisibleModifiersGroups = (modifierGroups: any) => {
  const isQr = store.getState().restaurant.isQr;
  const filteredModifiers = modifierGroups?.filter((groupItem: any) => {
    const modifier = groupItem.modifiers[0];
    return isQr
      ? modifier.onPrem === true || modifier.showOnQR === true
      : modifier.offPrem === true || modifier.showOnline === true;
  });

  return filteredModifiers && filteredModifiers.length > 0 ? filteredModifiers : null;
};

export const hasRequiredModifier = (modifierGroups: any) => {
  const filteredModifiers = getVisibleModifiersGroups(modifierGroups);
  if (filteredModifiers && filteredModifiers.length > 0) {
    return true;
  }
  return false;
};

export const getItemDetail = (itemId: number, categoryId?: number, menuId?: number, compeleteMenu?: StoreMenu[]) => {
  const itemByMenu = store.getState().menuMetadata.itemByMenu;
  compeleteMenu = compeleteMenu ? compeleteMenu : store.getState().menuMetadata.compeleteMenu;
  if (itemByMenu && compeleteMenu) {
    const itemRef = itemByMenu[itemId];
    const menuDetail =
      itemRef.length > 1 && categoryId && menuId
        ? itemRef.find((menu) => menu.categoryId === categoryId && menu.menuId === menuId)
        : itemRef[0];
    const item =
      compeleteMenu
        .find((menu) => menu.id === menuDetail?.menuId) // depend upon available menu
        ?.categories?.find((category) => category.categoryId === menuDetail?.categoryId)
        ?.items?.find((i) => i.id === Number(itemId)) ?? null;
    return item;
  }
  return null;
};

export const showOnMenu = (visibilitySettings: any) => {
  const isQr = store.getState()?.restaurant.isQr;
  const isCatering = store.getState()?.restaurant.isCatering;
  let settings: any = null;
  if (visibilitySettings) {
    if (isQr) {
      settings = visibilitySettings?.['QR'] ?? visibilitySettings?.['OnPrem'];
    } else if (isCatering) {
      settings = visibilitySettings?.['Catering'] ?? visibilitySettings?.['OffPrem'];
    } else {
      settings = visibilitySettings?.['Online'] ?? visibilitySettings?.['OffPrem'];
    }
    if (!settings) {
      return false;
    }
    return true;
  }
  return false;
};

export const checkModifierOutOfStock = (
  reqModifierGroups?: any[],
  selectedModifierIds?: number[],
  selectedModifierOptionIds?: number[]
) => {
  if (!reqModifierGroups) return false;

  return reqModifierGroups.some((mg: any) =>
    checkAllNestedConditions(mg.modifiers, selectedModifierIds, selectedModifierOptionIds)
  );
};
const isSelected = (id?: number, selectedIds?: number[]) => {
  if (!selectedIds || selectedIds.length === 0) return true; // backward compatible
  return id != null && selectedIds.includes(id);
};
export const checkAllNestedConditions = (
  modifiers?: IModifier[],
  selectedModifierIds?: number[],
  selectedModifierOptionIds?: number[]
): boolean => {
  for (const modifier of modifiers || []) {
    // 🔹 Skip modifier if not selected
    if (!isSelected(modifier.id, selectedModifierIds)) continue;

    // Modifier itself out of stock
    if (modifier.stockStatus === false) return true;

    const isNested = modifier.addNested && modifier.nestedModifiers?.length;

    /* ================= NON NESTED ================= */
    if (!isNested) {
      const maxSelection = modifier?.maxSelector ?? 1;
      const minSelector = modifier?.minSelector ?? 1;
      const options = (modifier.modifierOption || []).filter((opt) => isSelected(opt.id, selectedModifierOptionIds));

      // Any selected option out of stock
      const availableOptionsCount = options.filter((opt) => opt.isStockAvailable === true).length;
      if (availableOptionsCount < maxSelection && availableOptionsCount < minSelector) {
        return true; // not enough options available
      }
      const inStockOptions = options.filter((opt) => opt.isStockAvailable !== false);

      let totalAvailable = 0;

      if (modifier.multiSelect) {
        totalAvailable = inStockOptions.reduce((sum, opt) => sum + (opt.maxLimit || 1), 0);
      } else {
        totalAvailable = inStockOptions.length;
      }

      if (modifier.minSelector && totalAvailable < modifier.minSelector) {
        return true;
      }

      continue;
    }

    /* ================= NESTED ================= */
    let totalNestedAvailable = 0;
    for (const nested of modifier.nestedModifiers || []) {
      if (!isSelected(nested.id, selectedModifierIds)) continue;

      if (nested.stockStatus === false) continue;

      const nestedOptions = (nested.modifierOption || []).filter(
        (opt) => isSelected(opt.id, selectedModifierOptionIds) && opt.isStockAvailable !== false && !opt.isOptional
      );

      let nestedAvailable = 0;

      if (nested.multiSelect) {
        nestedAvailable = nestedOptions.reduce((sum, opt) => sum + (opt.maxLimit || 1), 0);
      } else {
        nestedAvailable = nestedOptions.length;
      }

      totalNestedAvailable += nestedAvailable;
    }

    if (modifier.minSelector && totalNestedAvailable < modifier.minSelector) {
      return true;
    }
  }

  return false;
};

export const validateCartItemsOnCheckout = async (items: CartItem[]) => {
  let isCartValid = true;
  const businessId = store.getState()?.restaurant?.selectedBusinessId;
  const { restaurantId, restaurantAlias } = store.getState()?.restaurant?.activeRestaurant as RestaurantMetadata;
  const menuVersion = store.getState()?.menuMetadata.menuVersion;
  const menuName = store.getState()?.menuMetadata.menuName;
  let compeleteMenu = store.getState()?.menuMetadata.compeleteMenu;
  let visibilitySettings = store.getState()?.settings?.visibilitySettings;
  const checkoutErrors: CheckoutError[] = [];

  // check menu version change
  if (restaurantId && businessId) {
    const pushError = (id: number, message: string) => {
      checkoutErrors.push({ id, message, isValid: false });
      isCartValid = false;
    };

    const pushValid = (id: number) => {
      checkoutErrors.push({ id, message: '', isValid: true });
    };
    const version = await getMenuVersion(restaurantId, businessId);
    if (menuVersion !== version && restaurantAlias && menuName) {
      //cart item compare with new menu data
      const allMenuData = await getAllMenuData(Number(restaurantId), Number(businessId));
      compeleteMenu = allMenuData?.menus;
      visibilitySettings = allMenuData?.visibilitySettings;
      updateAllMenuInPortal(allMenuData, menuName);
    }
    items.forEach((cartItem) => {
      const itemDetail = getItemDetail(cartItem.id, cartItem.categoryId, cartItem.menuId, compeleteMenu);

      if (itemDetail) {
        const menu = cartItem?.menuId ? compeleteMenu?.find((m) => m.id === cartItem.menuId) : null;

        if (!menu) {
          pushError(cartItem.id, message.ITEM.UNAVAILABLE);
          return;
        }
        const category = menu.categories.find((cat) => cat.categoryId === cartItem.categoryId);
        if (!category) {
          pushError(cartItem.id, message.ITEM.UNAVAILABLE);
          return;
        }

        if (
          !checkTimeBasedAvailability(visibilitySettings['Menu']?.[menu?.settingId]) ||
          !checkTimeBasedAvailability(visibilitySettings['Category']?.[category?.settingId]) ||
          !checkTimeBasedAvailability(visibilitySettings['Item']?.[itemDetail?.settingId])
        ) {
          checkoutErrors.push({
            id: cartItem.id,
            message: message.ITEM.UNAVAILABLE,
            isValid: false,
          });
          isCartValid = false;
          return;
        }
        if (
          !itemDetail ||
          itemDetail.stockStatus === StockStatus.OutOfStock ||
          itemDetail.stockStatus === StockStatus.False
        ) {
          pushError(cartItem.id, message.ITEM.OUT_OF_STOCK);
          return;
        }
        const { allSelectedModifierIds, allSelectedModifierOptionIds } = getSelectedModiiferIds(cartItem);
        if (
          checkModifierOutOfStock(
            itemDetail?.modifiers?.requiredModifierGroups,
            allSelectedModifierIds,
            allSelectedModifierOptionIds
          ) ||
          checkModifierOutOfStock(
            itemDetail?.modifiers?.optionalModifierGroups,
            allSelectedModifierIds,
            allSelectedModifierOptionIds
          )
        ) {
          pushError(cartItem.id, message.ITEM.OUT_OF_STOCK);
          return;
        }
        pushValid(cartItem.id);
      } else {
        pushError(cartItem.id, message.ITEM.UNAVAILABLE);
        return;
      }
    });
    store.dispatch(setCheckoutErrors({ checkoutErrors, isCartValid: isCartValid }));
    return isCartValid;
  }
  return isCartValid;
};

const getSelectedModiiferIds = (cartItem: CartItem) => {
  const allSelectedModifierIds: number[] = [];
  const allSelectedModifierOptionIds: number[] = [];

  cartItem.selectedModifierGroups.forEach((modGroups) => {
    const groups = Array.isArray(modGroups) ? modGroups : [modGroups];
    groups.forEach((modGroup) => {
      modGroup.modifiers?.forEach((modifier: any) => {
        allSelectedModifierIds.push(modifier.id);

        // modifier options
        modifier.modifierOption?.forEach((modOption: any) => {
          if (modOption.id) {
            allSelectedModifierOptionIds.push(modOption.id);
          }
        });

        // Nested modifiers
        modifier.nestedModifiers?.forEach((nestedMod: any) => {
          allSelectedModifierIds.push(nestedMod.id);

          nestedMod.modifierOption?.forEach((nestedModOption: any) => {
            if (nestedModOption.id) {
              allSelectedModifierOptionIds.push(nestedModOption.id);
            }
          });
        });
      });
    });
  });
  return { allSelectedModifierIds, allSelectedModifierOptionIds };
};

export const updateAllMenuInPortal = async (allMenuData: MenuPageDataType, tenantName: string) => {
  store.dispatch(
    setMenuMetaData({
      compeleteMenu: allMenuData?.menus,
      menuVersion: allMenuData?.menuVersion,
      menuName: tenantName,
    })
  );
  store.dispatch(setItemByMenu(allMenuData?.itemByMenu));
  store.dispatch(setItemAddOns(allMenuData?.itemAddOns));
  store.dispatch(
    setFilterAllergensAndTags({
      filterAllergens: allMenuData?.filterAllergens,
      filterTags: allMenuData?.filterTags,
    })
  );
  store.dispatch(setVisibilitySettings({ visibilitySettings: allMenuData?.visibilitySettings ?? {} }));
};

export const getDigitIndex = (value: string, cursor: number) => value.slice(0, cursor).replace(/\D/g, '').length;

export const getCursorFromDigitIndex = (formatted: string, digitIndex: number) => {
  let digitsSeen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) digitsSeen++;
    if (digitsSeen === digitIndex) return i + 1;
  }
  return formatted.length;
};

export async function generateQrCode(url: string): Promise<string> {
  try {
    return await QRCode.toDataURL(url);
  } catch (err) {
    console.error('QR Generation Error:', err);
    throw err;
  }
}

export const isLastOrderItemAvailable = (item: CategoryItem) => {
  const state = store.getState();
  const { compeleteMenu, itemByMenu } = state?.menuMetadata || {};
  const visibilitySettings = state?.settings?.visibilitySettings;

  let menuId: number | undefined = item?.menuId;

  if (!menuId && item.categoryId) {
    const found = itemByMenu?.[item.id]?.find((i) => i.categoryId === item.categoryId);
    menuId = found?.menuId;
  }
  const menu = menuId ? compeleteMenu?.find((m) => m.id === menuId) : null;

  if (item.menuId && menu && !checkTimeBasedAvailability(visibilitySettings?.Menu?.[menu.settingId])) return false;

  // 3️⃣ Category-level check
  if (menu && item.categoryId) {
    const category = menu.categories.find((cat) => cat.categoryId === item.categoryId);

    if (category && !checkTimeBasedAvailability(visibilitySettings?.Category?.[category.settingId])) return false;
  }

  // 4️⃣ Item-level check (always required)
  if (!checkTimeBasedAvailability(visibilitySettings?.Item?.[item?.settingId])) return false;

  return true;
};

export const calculateItemPriceWithModifiers = (basePrice: number, modifierGroups: any[]): number => {
  let totalPrice = basePrice;

  for (const group of modifierGroups || []) {
    for (const modifier of group?.modifiers || []) {
      if (modifier?.addNested) {
        for (const nestedModifier of modifier?.nestedModifiers || []) {
          for (const option of nestedModifier?.modifierOption || []) {
            const price = option?.originalPrice || option?.price || 0;
            const quantity = option?.orderedQuantity ?? 1;
            totalPrice += price * quantity;
          }
        }
      } else {
        for (const option of modifier?.modifierOption || []) {
          const price = option?.originalPrice || option?.price || 0;
          const quantity = option?.orderedQuantity ?? 1;
          totalPrice += price * quantity;
        }
      }
    }
  }

  return totalPrice;
};

export const trackMetaEvent = (event: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.fbq && typeof window.fbq.callMethod === 'function') {
    window.fbq('track', event, params, { eventID: params?.eventId });
  } else {
    console.warn('fbq not ready yet for event', event);
  }
};

// Merge overnight slots: if a day ends at 23:59 and the next day starts at 00:00,
// extend the current day's last slot to the next day's first slot end time.
export const mergeRestaurantHours = (restaurantHours: RestaurantTiming[]) => {
  const adjustedRestaurantHours: RestaurantTiming[] = [];
  const skipIndices = new Set<number>();

  for (let index = 0; index < restaurantHours.length; index++) {
    if (skipIndices.has(index)) continue;

    const curr = {
      ...restaurantHours[index],
      slots: restaurantHours[index]?.slots?.length ? [...restaurantHours[index].slots] : [],
    };
    const next = restaurantHours[index + 1];

    if (next) {
      const currentDayLastSlot = curr?.slots?.find((s) => s?.endTime?.startsWith('23:59'));
      const nextDayFirstSlot = next?.slots?.find((s) => s?.startTime?.startsWith('00:00'));

      // If both slots are the same (e.g., 12:00 AM to 12:00 AM), skip merging to avoid showing "12:00 AM to 12:00 AM"
      if (currentDayLastSlot?.startTime === nextDayFirstSlot?.startTime) {
        adjustedRestaurantHours.push(curr);
        continue;
      }

      if (currentDayLastSlot && nextDayFirstSlot) {
        // Extend current day's last slot end time to the next day's first slot end time
        // e.g. "8pm to :59pm" + "12am to 2am" becomes "8pm to 2am"
        curr.slots = curr.slots.map((s) =>
          s.endTime?.startsWith('23:59') ? { ...s, endTime: nextDayFirstSlot.endTime } : s
        ) as RestaurantTimingSlot[];

        if (next.slots.length === 1) {
          // Next day only has the midnight slot — skip it entirely
          skipIndices.add(index + 1);
        } else {
          // Remove the midnight slot from next day so it isn't double-shown
          restaurantHours[index + 1] = {
            ...next,
            slots: next?.slots?.filter((s) => !s?.startTime?.startsWith('00:00')) as RestaurantTimingSlot[],
          };
        }
      }
    }

    adjustedRestaurantHours.push(curr);
  }

  // Handle wrap-around: if the last day ends at 23:59 and the first day starts at 00:00,
  // merge the first day's midnight slot into the last day.
  if (adjustedRestaurantHours.length >= 2) {
    const lastDay = adjustedRestaurantHours[adjustedRestaurantHours.length - 1];
    const firstDay = adjustedRestaurantHours[0];
    const lastDayEndSlot = lastDay.slots.find((s) => s.endTime?.startsWith('23:59'));
    const firstDayStartSlot = firstDay.slots.find((s) => s.startTime?.startsWith('00:00'));

    if (lastDayEndSlot && firstDayStartSlot) {
      // Extend last day's slot end time to the first day's midnight slot end time
      lastDay.slots = lastDay.slots.map((s) =>
        s.endTime?.startsWith('23:59') ? { ...s, endTime: firstDayStartSlot.endTime } : s
      ) as RestaurantTimingSlot[];

      if (firstDay.slots.length === 1) {
        // First day only has the midnight slot — remove it entirely
        adjustedRestaurantHours.shift();
      } else {
        // Remove the midnight slot from the first day
        firstDay.slots = firstDay.slots.filter((s) => !s.startTime?.startsWith('00:00')) as RestaurantTimingSlot[];
      }
    }
  }

  return {
    adjustedRestaurantHours,
    skippedIndices: skipIndices,
  };
};
